// extracted by mini-css-extract-plugin
export default {"root":"DataListCheckbox__root--vpsSl","icon":"DataListCheckbox__icon--3bZj6","root_checked":"DataListCheckbox__root_checked--2m4AC"};